import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  Box,
  IconButton,
  FormControl,
  Stack,
  Pagination,
  TablePagination
} from "@mui/material";
import { data, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import edit from "../../../assets/images/editIcon.png";
import {
  ApiGetClientEntities,
  ApiGetAdminList,
  ApiPutStoreStatus,
  ApiPutUpdateClientEntity,
  ApiGetClientEntitiTemplate,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";

const ManageStore: React.FC = () => {
  const [adminUsers, setAdminUsers] = useState<any>([]);
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [status, setStatus] = useState({});
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [ClientId, setClientId] = useState(null);
   const [datalength, setdatalength] = useState<any>(null);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(5);

  const navigate = useNavigate();

  useEffect(() => {
    if (Clientlist.length > 2) {
      setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
      console.log("selectedClient", selectedClient)
      console.log("ClientId", ClientId)
    }
  }, [Clientlist]);

  const handleGetApiCall = async () => {
    try {
      const response: any = await ApiGetAdminList();
      setAdminUsers(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleGetClientList = async () => {
    const data = `?offset=${page*rowsPerPage}&limit=${rowsPerPage}${selectedClient ? `&clientGroupName=${selectedClient.clientGroupName}` : ''}`;

    
    try {
      const response: any = await ApiGetClientEntities(data);
      setClientEntityList(response.data);
      setdatalength(response.totalDataCount);
      console.log("rse store", response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const deleteStore = async (store: any, newStatus: string) => {
    try {
      const body = {
        clientEntityId: store?.clientEntityId,
        status: newStatus,
      };
      const response: any = await ApiPutStoreStatus(body);
      toast.success("Business Deleted successfully");
      console.log("Status updated successfully:", response);
      await handleGetClientList();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const addOrUpdateStore = (store?: any) => {
    if (store?.clientEntityId) {
      navigate(`/admin/add-or-update-store/update/${store?.clientEntityId}`, {
        state: { clientEntity: store },
      });
    } else {
      navigate("/admin/add-or-update-store/add");
    }
  };

  const navigateToViewEditors = (store?: any) => {
    navigate("/admin/view-editor-business", {
      state: { store },
    });
  };

  const navigateToViewJobCriteria = (store?: any) => {
    navigate("/admin/view-business-jobcriteria", {
      state: { store },
    });
  };
  const navigateToClientQuestion = (store?: any) => {
    navigate("/admin/create-client-template", {
      state: { store },
    });
  };

  const navigateToQuizQuestion = (store?: any) => {
    navigate("/admin/create-quiz-question", {
      state: { store },
    });
  };

  const handleChange = async (store: any, newStatus: string) => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      [store.clientEntityId.ClientID]: newStatus,
    }));

    setClientEntityList((prevList) =>
      prevList.map((item) =>
        item.clientEntityId === store.clientEntityId
          ? {
            ...item,
            clientEntityStatus: {
              ...item.clientEntityStatus,
              userStatus: newStatus,
            },
          }
          : item
      )
    );

    try {
      const body = {
        clientEntityId: store?.clientEntityId,
        status: newStatus,
      };
      const response: any = await ApiPutStoreStatus(body);
      handleGetApiCall();
      console.log("Status updated successfully:", response);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    console.log("Slected CLient", selectedClient)
    const fetchData = async () => {
     selectedClient !== null && await handleGetClientList();
      await handleGetApiCall();
    };
    fetchData();
    return () => { };
  }, [selectedClient,page, rowsPerPage]);

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
      const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
      ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      }; 

  return (
    <div className="manage-admin-container">
      <div className="manage-button">
        <Stack className="ml-2" direction="row" spacing={2}>
          <FormControl size="small" sx={{ width: 180 }}>
            <Autocomplete
              disablePortal
              id="mm-autocomplete"
              options={Clientlist}
              value={selectedClient}
              getOptionLabel={(option) => option?.clientGroupName}
              isOptionEqualToValue={(option, value) =>
                option.clientGroupDBName === value.clientGroupDBName
              }
              onChange={(event, newValue: any) => {
                setSelectedClient(newValue);
                setClientId(newValue?.clientGroupName || null);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Client" />
              )}
              size="small"
            />
          </FormControl>
        </Stack>
        <h1 className="common-manage-h1 text-center pl-4">Manage Business</h1>
        <div className="add-button common-manage-button">
          <Button
            variant="contained"
            onClick={() => addOrUpdateStore()}
            className="table-row-background "
          >
            Add New Business
          </Button>
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow className="table-row-background">
            <TableCell style={{ color: "#fff" }}>ID</TableCell>
            <TableCell style={{ color: "#fff" }}>Location Name</TableCell>
            <TableCell style={{ color: "#fff" }}>Hotel Type</TableCell>
            <TableCell style={{ color: "#fff", paddingLeft: "50px" }}>
              Editor
            </TableCell>
            <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>
              Job Criteria
            </TableCell>
            <TableCell
              className="pl-4"
              style={{ color: "#fff", paddingLeft: "35px" }}
            >
              Questions
            </TableCell>
            <TableCell
              className="pl-4"
              style={{ color: "#fff", paddingLeft: "35px" }}
            >
              Quiz
            </TableCell>
            <TableCell style={{ color: "#fff" }}>Active</TableCell>
            {/* <TableCell></TableCell> */}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clientEntityList.map((store) => (
            <TableRow key={store.clientEntityId}>
              <TableCell>{store.clientEntityId}</TableCell>
              <TableCell>{store.entityName}</TableCell>
              <TableCell>{store?.entityTypeId && store?.entityTypeId?.entityTypeName || 'undefined'}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToViewEditors(store)}
                  className="table-row-background"
                >
                  View Editors
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToViewJobCriteria(store)}
                  className="table-row-background"
                >
                  Job Criteria
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToClientQuestion(store)}
                  className="table-row-background"
                >
                  Questions
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigateToQuizQuestion(store)}
                  className="table-row-background"
                >
                  Quiz
                </Button>
              </TableCell>
              <TableCell>
                <div className="switch-admin">
                  <Switch
                    checked={store?.clientEntityStatus?.userStatus === "active"}
                    onChange={(e) => {
                      const newStatus = e.target.checked
                        ? "active"
                        : "inActive";
                      handleChange(store, newStatus); // Pass the store and the new status
                    }}
                    sx={{
                      '& .MuiSwitch-thumb': {
                        backgroundColor: store?.clientEntityStatus?.userStatus === "active" ? "#1976d2" : "#ccc !important"
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: store?.clientEntityStatus?.userStatus === "active" ? "#90caf9" : "#ccc"
                      } 
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </TableCell>
              {/* <TableCell>
                <IconButton
                  // variant="contained"
                  onClick={() => addOrUpdateStore(store)}
                  // className="table-row-background"
                >
                  <Box component='img' className="w-75" src={edit}></Box>
                </IconButton>
              </TableCell> */}
              <TableCell>
                <IconButton
                  // variant="contained"
                  onClick={() => addOrUpdateStore(store)}
                // className="table-row-background"
                >
                  <Box component="img" className="w-75" src={edit}></Box>
                </IconButton>
                <Button
                  variant="contained"
                  className="delete-transparent"
                  onClick={() => {
                    const isConfirmed = window.confirm(
                      "Are you sure you want to delete the Business?"
                    );
                    if (isConfirmed) {
                      deleteStore(store, "delete"); // Call the API or action
                    }
                  }}
                >
                  <DeleteIcon className="delete-icon" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default ManageStore;
